import { version } from 'react';
import { render } from 'react-dom';
import { createRoot } from 'react-dom/client';

export function createReactApp(shadowRoot: ShadowRoot, App: JSX.Element) {
  const currentVersion = parseInt(version);

  if (currentVersion >= 18) {
    const root = createRoot(shadowRoot);
    root.render(App);
  } else {
    const div = document.createElement('div');
    render(App, div);
    shadowRoot.appendChild(div);
  }
}
